import PropTypes from 'prop-types';
import * as SVG from './SVG';

/*
#tailwind
*/

const Logo = ({ width, height, mode, ...other }) => {
  const Svg = SVG[mode[0].toUpperCase() + mode.slice(1)];
  return (
    <div {...other}>
      <Svg width={width} height={height} />
    </div>
  );
};

Logo.propTypes = {
  mode: PropTypes.oneOf(['darkFull', 'darkBadge', 'lightFull', 'lightBadge']),
  height: PropTypes.string,
  width: PropTypes.string,
};

Logo.defaultProps = {
  mode: 'lightBadge',
  height: undefined,
  width: 'auto',
};

export default Logo;
